import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { DefaultLayoutComponent } from './layouts/default/default.component';
import { ExtraLayoutComponent } from './layouts/extra/extra.component';

import { AnalysisDetailsComponent } from './pages/analysis-details/analysis-details.component';
import { AuditTrailComponent } from './pages/audit/analysis-trail/analysis-trail.component';
import { AuthLogComponent } from './pages/audit/auth-log/auth-log.component';
import { BlogComponent } from './pages/blog/blog.component';
import { BlogDetailComponent } from './pages/blog/blog-detail/blog-detail.component';
import { ChromatogramsComponent } from './pages/chromatograms/chromatograms.component';
import { HomeComponent } from './pages/home/home.component';
import { NewAnalysisComponent } from './pages/new-analysis/new-analysis.component';
import { Page403Component } from './pages/extra-pages/page403/page403.component';
import { Page404Component } from './pages/extra-pages/page-404/page-404.component';
import { Page500Component } from './pages/extra-pages/page-500/page-500.component';
import { PageNotFoundComponent } from './pages/not-found/not-found.component';
import { PageSignIn1Component } from './pages/extra-pages/sign-in-1/sign-in-1.component';
import { PreviousAnalysisComponent } from './pages/previous-analysis/previous-analysis.component';
import { SmallMoleculeComponent } from './pages/small-molecule/small-molecule.component';
import { TemplateComponent } from './pages/template/template.component';
import { UserForgotPasswordComponent } from './pages/amplify-auth/user-forgot-password/user-forgot-password.component';
import { UserNewPasswordComponent } from './pages/amplify-auth/user-new-password/user-new-password.component';
import { UserPageComponent } from './user-page/user-page.component';
import { UserSignInComponent } from './pages/amplify-auth/user-sign-in/user-sign-in.component';
import { UserSignOutComponent } from './pages/amplify-auth/user-sign-out/user-sign-out.component';


const defaultRoutes: Routes = [
    { path: 'analysis-details/:id/:user', component: AnalysisDetailsComponent },
    { path: 'audit-trail', component: AuditTrailComponent },
    { path: 'auth-log',component: AuthLogComponent },
    { path: 'chromatograms/:id', component: ChromatogramsComponent },
    { path: 'chromatograms/:id/:user', component: ChromatogramsComponent },
    { path: 'molecule-analysis/:id/:user', component: SmallMoleculeComponent },
    { path: 'new-analysis', component: NewAnalysisComponent },
    { path: 'previous-analysis', component: PreviousAnalysisComponent },
    { path: 'template', component: TemplateComponent },
    { path: 'user-info', component: UserPageComponent },
    { path: '**', component: Page404Component },
];

const extraRoutes: Routes = [
    { path: 'blog', component: BlogComponent },
    { path: 'blogDetail/:id', component: BlogDetailComponent },
    { path: 'forgot-password', component: UserForgotPasswordComponent },
    { path: 'home', component: HomeComponent },
    { path: 'new-password', component: UserNewPasswordComponent },
    { path: 'page-403', component: Page403Component },
    { path: 'page-404', component: Page404Component },
    { path: 'page-500', component: Page500Component },
    { path: 'signin', component: UserSignInComponent },
    { path: 'signout', component: UserSignOutComponent },
];

const routes: Routes = [
    { 
        path: '',
        redirectTo: '/extra-layout/home',
        pathMatch: 'full'
    },
    { 
        path: 'default-layout',
        component: DefaultLayoutComponent,
        children: defaultRoutes,
        runGuardsAndResolvers: 'always'
    },
    { 
        path: 'extra-layout',
        component: ExtraLayoutComponent,
        children: extraRoutes
    },
    { 
        path: '**',
        component: DefaultLayoutComponent,
        children: defaultRoutes
    }
];

@NgModule({ 
    imports: [RouterModule.forRoot(routes, { useHash: true, onSameUrlNavigation: 'reload' })],
    exports: [RouterModule]
 })

export class AppRoutingModule { }
